<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Grupos</h2>
                </div>
                <div class="col-lg-2">
                    <br>
                    <button type="button" (click)="openModal(myModalAgregar)" class="boton fondoAmarillo blanco bold" > Crear <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg> </button>
                </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
                <select class="form-control" [(ngModel)]="filtroGrupos">
                  <option value="1">Grupos Activos</option>
                  <option value="2">Grupos Inactivos</option>
                </select><br>
              </div>
              <div class="col-lg-3">
                <button class="btn btn-success" (click)="getGruposFiltro()">Filtrar</button>
              </div>
              <div class="col-lg-3">
              </div>
              <div class="col-lg-3"></div>
            </div>
            <div class="row">
                <div class="col-lg-11">
                 
                    <!-- <div class="input-group mb-2 mr-sm-2">
                        <div class="input-group-prepend">
                          <div class="input-group-text">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-search" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                              </svg>
                          </div>
                        </div>
                        <input type="text" class="form-control" id="buscar" placeholder="Buscar">
                      </div> -->
                    <table class="table table-striped"  datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                        <thead>
                            <tr>
                                <td>ID</td>
                                <td>Escuela</td>
                                <td>Carrera</td>
                                <td>Grupo</td>
                                <td>Fecha de Foto</td>
                                <td>Fecha de Entrega</td>
                                <td>Categoría</td>
                                <td>Vendedor</td>
                                <td>Estatus</td>
                                <td>Fotos</td>
                                <td>Miembros</td>
                                <td>Datos Grupo</td>
                                <td>
                                  <div *ngIf="datosCliente.acceso_pagos == 1">Hoja de Entrega</div>
                                </td>
                                <td ><div *ngIf="datosCliente.acceso_pagos == 1">Cerrar</div></td>
                                <td ><div *ngIf="datosCliente.acceso_pagos == 1">Eliminar</div></td>
                                <!-- <td>Link Registro</td> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor = "let grupo of grupos" >
                                <td>{{grupo.id}}</td>
                                <td>{{grupo.escuela}}</td>
                                <td>{{grupo.carrera}}</td>
                                <td>{{grupo.nombre}}</td>
                                <td>{{grupo.fecha_foto}}</td>
                                <td>{{grupo.fecha_entrega}}</td>
                                <td>{{grupo.categoria}}</td>
                                <td>{{grupo.vendedor}}</td>
                                <td>{{grupo.estatus_grupo}}</td>
                                <td>
                                  <a href="fotos-grupos/{{grupo.id}}"><button class="btn btn-info">Fotos</button></a>
                                </td>
                                <td><button type="button" class="btn btn-success" (click)="getMiembrosGrupo(grupo.id)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                                  <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                  <path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
                                  <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                                </svg> Miembros</button></td>
                                <td><button type="button" class="btn btn-primary" (click)="getDatosGrupo(grupo.id)"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
                                  <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
                                </svg>Configuración</button></td>
                                <!-- <td><a href="/registro/{{grupo.id}}" target="_blank">Link</a><br>
                                  /registro/{{grupo.id}}
                                </td> -->
                                <td >
                                  <div *ngIf="datosCliente.acceso_pagos == 1">
                                   <a href="hoja-entrega/{{grupo.id}}"><button class="btn btn-primary">Hoja de entrega</button></a>
                                  </div>
                                </td>
                                <td><div  *ngIf="datosCliente.acceso_pagos == 1">
                                  <button class="btn btn-secondary" (click)="cerrarGrupo(grupo.id)">Cerrar</button>
                                </div></td>

                                <td><div *ngIf="datosCliente.acceso_pagos == 1">
                                  <button class="btn btn-danger" (click)="eliminarGrupo(grupo.id)">Eliminar</button>
                                </div></td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                </div>
                <div class="col-lg-1"></div>
            </div>

        </div>
    </div>
</div>

<ng-template #myModalAgregar let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Agregar Grupo</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <h5>Datos de Grupo</h5>
        <input type="text" class="form-control" placeholder="Nombre Grupo" [(ngModel)]="formulario.nombreGrupo"><br>
        <!-- <div class="input-group">
          <input class="form-control" placeholder="yyyy-mm-dd"
          name="dp" [(ngModel)]="formularioGrupo.fecha_graduacion" ngbDatepicker #d="ngbDatepicker">
          <div class="input-group-append">
              <button (click)="d.toggle()" type="button" class="input-group-text">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar3" viewBox="0 0 16 16">
                      <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/>
                      <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                  </svg>
              </button>
          </div>
      </div><br> -->

      
        <!-- <input type="text" class="form-control" placeholder="Fecha de Foto yyyy-mm-dd" [(ngModel)]="formulario.fechaFoto"><br> -->
        <!-- <input type="text" class="form-control" placeholder="Fecha de Entrega yyyy-mm-dd" [(ngModel)]="formulario.fechaEntrega"><br> -->
        <!-- <input type="text" class="form-control" placeholder="Fecha de Graduación yyyy-mm-dd" [(ngModel)]="formulario.fechaGraduacion"><br> -->
        <div class="form-group">
          <label for="dateOfBirth">Fecha de Foto</label>
          <div class="input-group">
            <input id="dateOfBirth" class="form-control" placeholder="Hora de Foto yyyy-mm-dd" [(ngModel)]="formulario.fechaFoto" name="dp" ngbDatepicker #dp="ngbDatepicker">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                  <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="dateOfBirth">Fecha de Entrega</label>
          <div class="input-group">
            <input id="dateOfBirth" class="form-control" placeholder="Fecha de Entrega yyyy-mm-dd" [(ngModel)]="formulario.fechaEntrega" name="dpa" ngbDatepicker #dpa="ngbDatepicker">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" (click)="dpa.toggle()" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                  <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>


        <div class="form-group">
          <label for="dateOfBirth">Fecha de Graduación</label>
          <div class="input-group">
            <input id="dateOfBirth" class="form-control" [(ngModel)]="formulario.fechaGraduacion" placeholder=" Fecha de Graduación yyyy-mm-dd" name="dpb" ngbDatepicker #dpb="ngbDatepicker">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" (click)="dpb.toggle()" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                  <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <select #institucionSelect class="form-control">
          <option value="" >Seleccione Escuela</option>
          <option *ngFor = "let institucion of instituciones" [value]="institucion.id">{{institucion.nombre}}</option>
        </select>
       <br><br>
        <select #carrera class="form-control">
            <option value="">Seleccione Carrera</option>
            <option *ngFor = "let carrera of carreras" [value]="carrera.id">{{carrera.nombre}}</option>
        </select>
        <br><br>

        <select class="form-control" [(ngModel)]="formulario.categoria">
          <option value="">Seleccione Categoría</option>
          <option *ngFor="let categoria of categorias" [value]="categoria.id">{{categoria.nombre}}</option>
        </select><br>

        <select class="form-control" [(ngModel)]="formulario.vendedor">
          <option value="">Seleccione Vendedor</option>
          <option *ngFor="let vendedor of vendedores" [value]="vendedor.id">{{vendedor.nombre}}</option>
        </select><br>
        
        
        <h5>Datos de Representante</h5>
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario.nombre"><br>
        <input type="text" class="form-control" placeholder="Apellidos" [(ngModel)]="formulario.apellidos"><br>
        <input type="text" class="form-control" placeholder="Celular" [(ngModel)]="formulario.celular"><br>
        <input type="text" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formulario.email"><br>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="agregarGrupo(carrera.value, institucionSelect.value)">Agregar Grupo</button>
    </div>
</ng-template>


<div id="click" (click)="openModal2(mymodal)"></div>
<ng-template #mymodal let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Miembros</h4>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
      <br>
      <table class="table table-striped center">
          <thead>
              <tr>
                  <td>Nombre</td>
                  <td>Celular</td>
                  <td>E-mail</td>
                  <!-- <td>Monto de compra</td> -->
                  <!-- <td>Monto Pagado</td> -->
                  <td>Porcentaje Pagado</td>
                  <td>Perfil</td>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let miembro of miembros">
                  <td>{{miembro.nombre}}</td>
                  <td>{{miembro.celular}}</td>
                  <td>{{miembro.email}}</td>
                  <!-- <td>{{miembro.monto | currency}}</td> -->
                  <!-- <td>{{miembro.pagado | currency}}</td> -->
                  <td>{{miembro.avance}}%</td>
                  <td><a href="detalle-paquete/{{miembro.id}}"><button type="button"  class="btn btn-success">Ver Paquete</button></a></td>
              </tr>
          </tbody>
      </table>
  
    </div>
    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-success blanco bold" >Agregar Miembro <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg> </button> -->
      <button type="button" class="btn btn-outline-dark" (click)="dismissAll()">Cerrar</button>
    </div>
</ng-template>


<div id="click2" (click)="openModal(mymodalDatos)"></div>
<ng-template #mymodalDatos let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Datos Generales Grupo</h4>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
      <br>
      <h5>Datos Generales</h5>
      <button class="btn btn-success" (click)="confirmarAvance(datosGrupo.id)">Confirmar Avances</button>

      <p>
          {{datosGrupo.nombre}}<br>
          {{datosGrupo.escuela}}<br>
          {{datosGrupo.carrera}}<br>
          <br>
      </p>
          <span class="bold">Categorías</span>
          <div *ngFor="let categoriaG of categoriasG">
            {{categoriaG.nombre}}<br>
          </div>
          <br>
        <p>
          <!-- {{datosGrupo.categoria_nombre}}<br> -->
          {{datosGrupo.estatus_grupo}}<br>
          Personas: {{datosGrupo.numero_personas}}<br>
          <a href="/registro/{{datosGrupo.id}}" target="_blank">Link de Registro</a><br>
          <a href="/registrarme/{{datosGrupo.id}}" target="_blank" class="bold">NUEVO Link de Registro</a><br>
          <a href="/cliente/inicio/{{datosGrupo.id}}" target="_blank" class="bold">NUEVO Link de Registro v2</a><br>
          <a href="/registro-interno/{{datosGrupo.id}}" target="_blank" class="bold">Link de Registro  INTERNO</a><br>

          <a href="{{datosGrupo.link_whatsapp}}" target="_blank">Link Grupo What's App</a><br>

          <a href="{{datosGrupo.link_drive}}" target="_blank">Link Drive Fotos</a><br>
          
          Forma de pago: 
          <span *ngIf="datosGrupo.forma_pago == 1">Plan 1 50/50</span>
          <span *ngIf="datosGrupo.forma_pago == 2">Plan 2 30/30/40</span><br>
          Fechas de pago:<br>
          {{datosGrupo.fecha_pago_uno}}<br>
          {{datosGrupo.fecha_pago_dos}}<br>
          <span *ngIf="datosGrupo.forma_pago == 2">{{datosGrupo.fecha_pago_tres}}<br></span>
      </p>

      <h5>Promociones</h5>
      <p>{{datosGrupo.promociones}}</p>

      <h5>Fecha Graduación</h5>
      <p>{{datosGrupo.fecha_graduacion}}</p>
    
      <h5>Datos de Foto</h5>
      <p>{{datosGrupo.fecha_foto}} a las {{datosGrupo.hora_toma_foto}} en {{datosGrupo.lugar_toma_foto}}</p>

  
      <h5>Datos de entrega</h5>
      <p>{{datosGrupo.fecha_entrega}} en {{datosGrupo.lugar_entrega}}</p>

      <h5>Generación</h5>
      <p>{{datosGrupo.generacion}}</p>

      <h5>Fondo</h5>
      <p>{{datosGrupo.fondo}}</p>

      <h5>Color Estolas</h5>
      <p>{{datosGrupo.estola}}</p>

      <h5>Sesión Temática</h5>
      <p>{{datosGrupo.sesion_tematica}}</p>
      
      <h5>Imágenes</h5>
      <div *ngIf="datosGrupo.escudo == ''; else escudouno">
        <img src="assets/img/auri.png" width="200px">
      </div>

      <div *ngIf="datosGrupo.escudo2 == ''; else escudodos">
        <img src="assets/img/auri.png" width="200px">
      </div>

      <ng-template #escudouno>
        <ng-container>
          <img src="{{enviroment}}{{datosGrupo.escudo}}" width="200px">
        </ng-container>
      </ng-template>

      <ng-template #escudodos>
        <ng-container>
          <img src="{{enviroment}}{{datosGrupo.escudo2}}" width="200px">
        </ng-container>
      </ng-template>
      

      <div class="familias-v2-box">
        <div class="d-flex align-items-center justify-content-between flex-wrap">
          <h5 class="mb-0">Familias disponibles</h5>
          <span *ngIf="cargandoFamiliasV2" class="badge badge-info">Cargando...</span>
        </div>
        <input type="text" class="form-control familias-v2-search" placeholder="Buscar familia..." [(ngModel)]="filtroFamiliasV2">
        <p class="text-muted small mb-3">Sin familias seleccionadas, el grupo ve todas las familias activas.</p>

        <div class="row">
          <div class="col-md-6">
            <div class="familias-v2-section">
              <div class="familias-v2-title">Seleccionadas ({{familiasV2Seleccionadas.length}})</div>
              <div *ngIf="familiasV2Seleccionadas.length == 0" class="text-muted small familias-v2-empty">Sin resultados</div>
              <div class="familia-v2-item familia-v2-item-selected" *ngFor="let familia of familiasV2Seleccionadas">
                <div class="familia-v2-copy">
                  <strong>{{familia.nombre}}</strong>
                  <small *ngIf="familia.descripcion">{{familia.descripcion}}</small>
                </div>
                <button type="button" class="btn btn-sm btn-outline-danger" [disabled]="guardandoFamiliaV2 == familia.id" (click)="quitarFamiliaV2(familia.id)">Quitar</button>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-3 mt-md-0">
            <div class="familias-v2-section">
              <div class="familias-v2-title">No seleccionadas ({{familiasV2NoSeleccionadas.length}})</div>
              <div *ngIf="familiasV2NoSeleccionadas.length == 0" class="text-muted small familias-v2-empty">Sin resultados</div>
              <div class="familia-v2-item" *ngFor="let familia of familiasV2NoSeleccionadas">
                <div class="familia-v2-copy">
                  <strong>{{familia.nombre}}</strong>
                  <small *ngIf="familia.descripcion">{{familia.descripcion}}</small>
                </div>
                <button type="button" class="btn btn-sm btn-outline-success" [disabled]="guardandoFamiliaV2 == familia.id" (click)="asignarFamiliaV2(familia.id)">Asignar</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-success blanco bold" >Agregar Miembro <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg> </button> -->
      <a href="detalle-grupo/{{datosGrupo.id}}"><button type="button" class="btn btn-success">Actualizar</button></a>
      <button type="button" class="btn btn-outline-dark" (click)="dismissAll()">Cerrar</button>
    </div>
  </ng-template>


  <div id="click3" (click)="openModal(mymodalActualizar)"></div>
<ng-template #mymodalActualizar let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Actualizar Datos Generales Grupo</h4>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">

     

      <span class="bold">Nombre del Grupo</span>
      <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formularioEdit.nombre_grupo"><br>

      <span class="bold">Número de Personas</span>
      <input type="text" class="form-control" placeholder="Número de Personas" [(ngModel)]="formularioEdit.numero_personas"><br>
    
      <span class="bold">Forma de Pago</span><br>
      <select #formaPagoGrupo [(ngModel)]="formularioEdit.forma_pago" class="form-group">
        <option value="0" >Seleccione Forma de Pago</option>
        <option value="1" >Plan 1 50/50</option>
        <option value="2">Plan 2 30/30/40</option>
      </select><br>

      <div *ngIf="formularioEdit.forma_pago != 0">

        <div class="input-group">
          <input id="fecha_pago_1" class="form-control"  [(ngModel)]="formularioEdit.fecha_pago_uno" placeholder="Fecha de pago 1 yyyy-mm-dd" name="dp1b" ngbDatepicker #dp1b="ngbDatepicker">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
              </svg>
            </button>
          </div>
        </div>
        <br>

        <div class="input-group">
          <input id="fecha_pago_2" class="form-control" placeholder="Fecha de pago 2 yyyy-mm-dd" [(ngModel)]="formularioEdit.fecha_pago_dos" name="dp2b" ngbDatepicker #dp2b="ngbDatepicker">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="dp2b.toggle()" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
              </svg>
            </button>
          </div>
        </div>
        <br>
      </div>  

      <div *ngIf="formularioEdit.forma_pago == 2">
        <div class="input-group">
          <input id="fecha_pago_2" class="form-control" placeholder="Fecha de pago 3 yyyy-mm-dd" [(ngModel)]="formularioEdit.fecha_pago_tres" value="formularioEdit.fecha_pago_tres" name="dp3b" ngbDatepicker #dp3b="ngbDatepicker">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="dp3b.toggle()" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
              </svg>
            </button>
          </div>
        </div>
        <br>
      </div>

      <span class="bold">Fecha de Graduación</span>
      <input type="text" class="form-control" placeholder="Fecha de Graduación" [(ngModel)]="formularioEdit.fecha_graduacion"><br>

      <span class="bold">Fecha de Entrega</span>
      <input type="text" class="form-control" placeholder="Fecha de Entrega" [(ngModel)]="formularioEdit.fecha_entrega"><br>
      
      <span class="bold">Lugar de Entrega</span>
      <input type="text" class="form-control" placeholder="Lugar de Entrega" [(ngModel)]="formularioEdit.lugar_entrega"><br>

      <span class="bold">Fecha de Foto</span>
      <input type="text" class="form-control" placeholder="Fecha de Foto" [(ngModel)]="formularioEdit.fecha_foto"><br>
      
      <span class="bold">Hora de Foto</span>
      <ngb-timepicker [(ngModel)]="formularioEdit.hora_foto"></ngb-timepicker>
      <!-- <input type="text" class="form-control" placeholder="Hora de Foto hh:mm" [(ngModel)]="formularioEdit.hora_foto"><br> -->

      <span class="bold">Lugar de Foto</span>
      <input type="text" class="form-control" placeholder="Lugar de Fotografía" [(ngModel)]="formularioEdit.lugar_foto"><br>

      <span class="bold">Link de What's App</span>
      <input type="text" class="form-control" placeholder="Grupo de What's App" [(ngModel)]="formularioEdit.link_whatsapp"><br>

      <span class="bold">Promociones</span>
      <textarea class="form-control" placeholder="Promociones" [(ngModel)]="formularioEdit.promociones"></textarea><br>

      <select #institucionEditSelect>
        <option value="" class="form-control">Seleccione Escuela</option>
        <option *ngFor = "let institucion of instituciones" [value]="institucion.id" [attr.selected]="institucion.id==institucionSelected ? true : null">{{institucion.nombre}}</option>
      </select>
     <br><br>

      <select #carreraEditSelect>
          <option value="" class="form-control">Seleccione Carrera</option>
          <option *ngFor = "let carrera of carreras" [value]="carrera.id" [attr.selected]="carrera.id==carreraSelected ? true : null">{{carrera.nombre}}</option>
      </select>
      <br><br>

      <select class="form-control" [(ngModel)]="formularioEdit.categoria">
        <option value="">Seleccione Categoría</option>
        <option *ngFor="let categoriaE of categorias" [value]="categoriaE.id">{{categoriaE.nombre}}</option>
    </select><br>

      

      <span class="bold">Generación</span>
      <input type="text" class="form-control" placeholder="Generación" [(ngModel)]="formularioEdit.generacion"><br>

      <span class="bold">Fondo de Fotografía</span>
      <select #fondo class="form-control">
        <option value="">Seleccione Fondo </option>
        <option *ngFor="let fondo of fondos" [value]="fondo.id" [attr.selected]="fondo.nombre==formularioEdit.fondo ? true : null">{{fondo.nombre}}</option>
      </select>
      <br>
      
      <span class="bold">Color de Estola</span>
      <select #estola class="form-control">
        <option value="">Seleccione Color</option>
        <option *ngFor="let estola of estolas" [value]="estola.id" [attr.selected]="estola.nombre==formularioEdit.estola ? true : null">{{estola.nombre}}</option>
      </select>
      <br>
      
      <span class="bold">Sesión Temática</span>
      <select #tematica class="form-control">
        <option value="">Seleccione Sesión Temática</option>
        <option *ngFor="let sesion of sesiones" [value]="sesion.id" [attr.selected]="sesion.id==sesion_tematicaid ? true : null">{{sesion.nombre}}</option>
      </select>

      <span class="bold">Estatus</span>
      <select #estatus_grupo class="form-control">
        <option value="">Seleccione Estatus</option>
        <option *ngFor="let estate of estatus" [value]="estate.id" [attr.selected]="estate.id==estatusid ? true : null">{{estate.nombre}}</option>
      </select>
      <br>

      <img src="{{enviroment}}{{datosGrupo.escudo}}" width="200px">
      Imagen:<br>
        <input (change)="imageChange($event.target.files)" type="file"accept="image/*" id="imagen"><br><br>

      <img src="{{enviroment}}{{datosGrupo.escudo2}}" width="200px">
      Imagen 2:<br>
      <input (change)="imageChange2($event.target.files)" type="file"accept="image/*" id="imagen2"><br><br>
    </div>
    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-success blanco bold" >Agregar Miembro <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg> </button> -->
      <button type="button" class="btn btn-warning" (click)="updateGrupo(grupoid, institucionEditSelect.value, carreraEditSelect.value, estola.value, fondo.value, tematica.value, estatus_grupo.value)">Actualizar</button>
      <button type="button" class="btn btn-outline-dark" (click)="dismissAll()">Cerrar</button>
    </div>
  </ng-template>
